/* RESPONSIBLE TEAM: team-omni */
import EmbercomBaseSerializer from 'embercom/serializers/base/embercom-base-serializer';
import { getOwner } from '@ember/application';
import type ApplicationInstance from '@ember/application/instance';
import type Store from '@ember-data/store';
import type ModelSchema from '@ember-data/model';
import type AppService from 'embercom/services/app-service';

export default class FinAgentApiSettingsSerializer extends EmbercomBaseSerializer {
  normalizeQueryRecordResponse(
    store: Store,
    primaryModelClass: ModelSchema,
    payload: any,
    id: string | number,
    requestType: string,
  ) {
    // The backend doesn't return an id for this singleton resource,
    // so we get the app id from the app service
    if (payload && !payload.id) {
      let owner = getOwner(this) as ApplicationInstance;
      let appService = owner.lookup('service:app-service') as AppService;
      if (appService?.app?.id) {
        payload.id = appService.app.id;
      }
    }

    return super.normalizeQueryRecordResponse(store, primaryModelClass, payload, id, requestType);
  }
}

declare module 'ember-data/types/registries/serializer' {
  export default interface SerializerRegistry {
    'fin-agent-api/settings': FinAgentApiSettingsSerializer;
  }
}
